import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { Helmet } from 'react-helmet'
import marked from 'marked'

const Changelog = ({ store }) => {
  const getMarkdownText = () => {
    const markup = marked(store.getChangelog)
    return { __html: markup }
  }

  return (
    <section className='modal-dialog'>
      <Helmet title={store.__('Release history')} />
      <h2>{store.__('Release history')}</h2>
      {store.getChangelog && <div dangerouslySetInnerHTML={getMarkdownText()} />}
    </section>
  )
}

Changelog.propTypes = {
  store: PropTypes.object.isRequired
}

export default inject('store')(observer(Changelog))
